/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal";
import { GpsQualityPb_Enum, gpsQualityPb_EnumFromJSON, gpsQualityPb_EnumToJSON } from "./gps_quality";

export const protobufPackage = "sensors";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface GpsQualityOverridePb {
  utime: number;
  overrideEnabled: boolean;
  gpsQualityOverride: GpsQualityPb_Enum;
}

function createBaseGpsQualityOverridePb(): GpsQualityOverridePb {
  return { utime: 0, overrideEnabled: false, gpsQualityOverride: 0 };
}

export const GpsQualityOverridePb = {
  encode(message: GpsQualityOverridePb, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.utime !== 0) {
      writer.uint32(8).sint64(message.utime);
    }
    if (message.overrideEnabled === true) {
      writer.uint32(16).bool(message.overrideEnabled);
    }
    if (message.gpsQualityOverride !== 0) {
      writer.uint32(24).int32(message.gpsQualityOverride);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GpsQualityOverridePb {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGpsQualityOverridePb();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.utime = longToNumber(reader.sint64() as Long);
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.overrideEnabled = reader.bool();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.gpsQualityOverride = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GpsQualityOverridePb {
    return {
      utime: isSet(object.utime) ? globalThis.Number(object.utime) : 0,
      overrideEnabled: isSet(object.overrideEnabled) ? globalThis.Boolean(object.overrideEnabled) : false,
      gpsQualityOverride: isSet(object.gpsQualityOverride) ? gpsQualityPb_EnumFromJSON(object.gpsQualityOverride) : 0,
    };
  },

  toJSON(message: GpsQualityOverridePb): unknown {
    const obj: any = {};
    if (message.utime !== 0) {
      obj.utime = Math.round(message.utime);
    }
    if (message.overrideEnabled === true) {
      obj.overrideEnabled = message.overrideEnabled;
    }
    if (message.gpsQualityOverride !== 0) {
      obj.gpsQualityOverride = gpsQualityPb_EnumToJSON(message.gpsQualityOverride);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GpsQualityOverridePb>, I>>(base?: I): GpsQualityOverridePb {
    return GpsQualityOverridePb.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GpsQualityOverridePb>, I>>(object: I): GpsQualityOverridePb {
    const message = createBaseGpsQualityOverridePb();
    message.utime = object.utime ?? 0;
    message.overrideEnabled = object.overrideEnabled ?? false;
    message.gpsQualityOverride = object.gpsQualityOverride ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
